import firebaseInstance from "../util/firebase";

export default {
  apply(router, store) {
    router.beforeEach(async (to, from, next) => {
      if(to.path == '/' && to.query.mode && to.query.mode == 'resetPassword') {
        next({
          path: `/resetmypassword/${to.query.oobCode}`,
          query: {...to.query}
        })
        return
      }
        firebaseInstance.auth().onAuthStateChanged(data => {
          if (data) {
            if (!from.name) {
              if (to.name == "LandingPage") {
                next({ name: "ProjectsPage" });
              } else {
                store
                  .dispatch("loggedIn", {
                    uid: data.uid,
                    emailVerified: data.emailVerified
                  })
                  .then(() => this.getUserData(to, store))
                  .then(() => {
                    console.log('should to go next')
                    next()
                  });
              }
            } 
            else {
              next() 
            }
          } else {
            if (
              ![
                "LoginPage",
                "RegisterPage",
                "ForgotPasswordPage",
                "ResetPasswordPage"
              ].includes(to.name)
            ) {
              next({ name: "LoginPage", query: { redirect: to.fullPath} });
            } else {
              next()
            }
          }
        });
    });
  },
  async getUserData(route, store) {
    var fullPath = route.path;
    const data = {
      emailVerified: store.getters.emailVerified,
      uid: store.getters.uid,
      fullPath,
      path: fullPath.substr(1, fullPath.lastIndexOf("/") - 1),
      key: fullPath.substr(fullPath.lastIndexOf("/") + 1, fullPath.length)
    };
    await store.dispatch("getUserData", data)
    await store.dispatch("getMyProjects", {
      projectList: store.getters.myProjectList
    })
    await store.dispatch("getCompanyInfo", {
      myCompany: store.getters.userData.myCompany
    });
    
    return Promise.resolve(true);
  }
};
